// extracted by mini-css-extract-plugin
module.exports = {"tasks":"tasksContent_tasks__2cl_U"};